// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ExpenseAdmin_ProjectFragmentDoc } from '../../expenses/ExpensesAdmin.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ExpensesPageMetadataQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ExpensesPageMetadataQuery = { __typename?: 'Query', project:
    | { __typename?: 'StandaloneProject', unallocatedAmountInCents: number, id: string, name: string, expenses: Array<{ __typename?: 'Expense', id: string, amountInCents: number }> }
    | { __typename?: 'Region', unallocatedAmountInCents: number, id: string, name: string, expenses: Array<{ __typename?: 'Expense', id: string, amountInCents: number }> }
    | { __typename?: 'Market', unallocatedAmountInCents: number, id: string, name: string, expenses: Array<{ __typename?: 'Expense', id: string, amountInCents: number }> }
    | { __typename?: 'Community', unallocatedAmountInCents: number, id: string, name: string, expenses: Array<{ __typename?: 'Expense', id: string, amountInCents: number }> }
    | { __typename?: 'Subdivision', unallocatedAmountInCents: number, id: string, name: string, expenses: Array<{ __typename?: 'Expense', id: string, amountInCents: number }> }
    | { __typename?: 'Lot', unallocatedAmountInCents: number, id: string, name: string, expenses: Array<{ __typename?: 'Expense', id: string, amountInCents: number }> }
    | { __typename?: 'Structure', unallocatedAmountInCents: number, id: string, name: string, expenses: Array<{ __typename?: 'Expense', id: string, amountInCents: number }> }
    | { __typename?: 'Unit', unallocatedAmountInCents: number, id: string, name: string, expenses: Array<{ __typename?: 'Expense', id: string, amountInCents: number }> }
   };


export const ExpensesPageMetadataDocument = gql`
    query ExpensesPageMetadata($projectId: ID!) {
  project(id: $projectId) {
    ...ExpenseAdmin_Project
  }
}
    ${ExpenseAdmin_ProjectFragmentDoc}`;

/**
 * __useExpensesPageMetadataQuery__
 *
 * To run a query within a React component, call `useExpensesPageMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensesPageMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensesPageMetadataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useExpensesPageMetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExpensesPageMetadataQuery, ExpensesPageMetadataQueryVariables> & ({ variables: ExpensesPageMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpensesPageMetadataQuery, ExpensesPageMetadataQueryVariables>(ExpensesPageMetadataDocument, options);
      }
export function useExpensesPageMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpensesPageMetadataQuery, ExpensesPageMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpensesPageMetadataQuery, ExpensesPageMetadataQueryVariables>(ExpensesPageMetadataDocument, options);
        }
// @ts-ignore
export function useExpensesPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ExpensesPageMetadataQuery, ExpensesPageMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ExpensesPageMetadataQuery, ExpensesPageMetadataQueryVariables>;
export function useExpensesPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpensesPageMetadataQuery, ExpensesPageMetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ExpensesPageMetadataQuery | undefined, ExpensesPageMetadataQueryVariables>;
export function useExpensesPageMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpensesPageMetadataQuery, ExpensesPageMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpensesPageMetadataQuery, ExpensesPageMetadataQueryVariables>(ExpensesPageMetadataDocument, options);
        }
export type ExpensesPageMetadataQueryHookResult = ReturnType<typeof useExpensesPageMetadataQuery>;
export type ExpensesPageMetadataLazyQueryHookResult = ReturnType<typeof useExpensesPageMetadataLazyQuery>;
export type ExpensesPageMetadataSuspenseQueryHookResult = ReturnType<typeof useExpensesPageMetadataSuspenseQuery>;
export type ExpensesPageMetadataQueryResult = ApolloReactCommon.QueryResult<ExpensesPageMetadataQuery, ExpensesPageMetadataQueryVariables>;